import React from 'react';

import _ from '../locale';

type FieldProps<FormData, FormComponentType extends React.ComponentType<any>> = {
    isRequired?: boolean;
    name: keyof FormData;
    formData: FormData;
    errors: Record<keyof FormData, string> & { server?: string };
    localePrefix: string;
    FormComponent: FormComponentType;
    onChange?: (e: React.ChangeEvent<any>) => void;
} & Omit<React.ComponentProps<FormComponentType>, 'value' | 'label'>;

const Field = <T extends object, FormComponentType extends React.ComponentType<any>>({
    name,
    isRequired,
    formData,
    errors,
    localePrefix,
    FormComponent,
    onChange,
    ...props
}: React.PropsWithChildren<FieldProps<T, FormComponentType>>) => (
    <FormComponent
        name={name}
        value={formData[name]}
        label={`${_(localePrefix + name)}${isRequired ? ' *' : ''}`}
        onChange={onChange}
        error={errors && errors[name]}
        isRequired={isRequired}
        {...props}
    />
);

export default Field;
